import { API } from 'config/axios';
import { serverFetch } from 'utils/serverFetch';
import { getNewSlugURL } from 'utils/getNewSlugURL';

export const handleDetectSlugsSSR = async (ctx, reqBody, locale) => {
  let renderErrorPage = false;
  let slugSSR = null;
  let newPath;

  const { success, data } = await serverFetch(ctx, API.detectSlugs, null, 'post', reqBody);
  if (success && data) {
    data.slugs.forEach((slug) => {
      if (slug.resource_id === null || slug.slug_type === null) {
        renderErrorPage = true;
      }
    });
    if (!renderErrorPage) {
      newPath = getNewSlugURL(data.slugs, locale);
      slugSSR = data;
    }
  } else renderErrorPage = true;

  return {
    newPath,
    renderErrorPage,
    slugSSR,
  };
};
